import { render, staticRenderFns } from "./PortDispatches.vue?vue&type=template&id=3ef8c587"
import script from "./PortDispatches.vue?vue&type=script&lang=js"
export * from "./PortDispatches.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports